
import { defineComponent, PropType } from 'vue'
import { VulnerabilityOccurrenceFixability } from '~/types/types'

type FixabilityConfig = {
  text: string
  icon: string
  color: string
}

export default defineComponent({
  name: 'FixabilityIndicator',
  props: {
    fixability: {
      type: String as PropType<VulnerabilityOccurrenceFixability>,
      default: VulnerabilityOccurrenceFixability.Unfixable,
      validator: (value: string) =>
        Object.values(VulnerabilityOccurrenceFixability).includes(
          value as VulnerabilityOccurrenceFixability
        )
    }
  },
  computed: {
    config(): FixabilityConfig {
      if (this.fixability === VulnerabilityOccurrenceFixability.AutoFixable) {
        return {
          text: 'Automatically fixable',
          icon: 'band-aid-magic',
          color: 'juniper-9'
        }
      }

      if (this.fixability === VulnerabilityOccurrenceFixability.Unfixable) {
        return {
          text: 'Not fixable',
          icon: 'band-aid',
          color: 'vanilla-100'
        }
      }

      return {
        text: 'Fixable',
        icon: 'band-aid',
        color: 'juniper-9'
      }
    },
    text() {
      return this.config.text
    },
    icon() {
      return this.config.icon
    },
    color() {
      return this.config.color
    }
  }
})
